module.exports = __webpack_public_path__ + "static/img/background@2x.fbfd442.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logisticsBigData/background@2x.png
// module id = JhpD
// module chunks = 44